module.exports = __webpack_public_path__ + "static/media/diversification.eb040e56.png";